import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePspAuth } from '../context/PspAuthContext';
import { subscriptionApi } from '../services/pspApi';
import moment from 'moment';

const Home = () => {
    const { friendly_url } = useParams();
    const navigate = useNavigate();
    const { candidate } = usePspAuth();
    const base = `/processos-seletivos/${friendly_url}`;

    const [subscriptions, setSubscriptions] = useState([]);
    const [loading, setLoading] = useState(true);

    const firstName = ((candidate && (candidate.social_name || candidate.name)) || '').split(' ')[0] || 'Candidato';

    useEffect(() => {
        let isMounted = true;
        const loadSubscriptions = async () => {
            setLoading(true);
            try {
                const res = await subscriptionApi.mySubscriptions();
                if (isMounted && res && res.status === 1) {
                    setSubscriptions(res.subscriptions || []);
                }
            } catch (e) {
                console.error('Erro ao carregar inscrições:', e);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        loadSubscriptions();
        return () => { isMounted = false; };
    }, []);

    const getStatusBadge = (status) => {
        switch (status) {
            case 'aprovada':
                return { text: 'Aprovada', modifier: 'psp-subscription-card__badge--approved' };
            case 'reprovada':
                return { text: 'Não Aprovada', modifier: 'psp-subscription-card__badge--rejected' };
            case 'reserva':
                return { text: 'Cadastro Reserva', modifier: 'psp-subscription-card__badge--reserve' };
            case 'em_andamento':
            default:
                return { text: 'Em Análise / Andamento', modifier: 'psp-subscription-card__badge--in-progress' };
        }
    };

    return (
        <div className="psp-portal-main psp-portal-main--dashboard psp-fade-in">
            {/* Header de Boas-vindas */}
            <div className="psp-welcome-card">
                <div>
                    <h1 className="psp-welcome-card__title">
                        Olá, {firstName}!
                    </h1>
                    <p className="psp-welcome-card__subtitle">
                        Acompanhe aqui o andamento de todas as suas candidaturas aos processos seletivos.
                    </p>
                </div>
                <button
                    type="button"
                    onClick={() => navigate(base)}
                    className="psp-btn psp-btn--primary psp-btn--inline psp-btn--md"
                >
                    <i className="fas fa-search psp-icon--mr-8" />
                    Ver Vagas Abertas
                </button>
            </div>

            {/* Listagem de Inscrições */}
            <h2 className="psp-section-heading">
                <i className="fas fa-id-card psp-icon--blue" />
                Minhas Inscrições
            </h2>

            {loading ? (
                <div className="psp-loading">
                    <i className="fas fa-spinner fa-spin fa-2x" />
                    <p>Carregando suas inscrições...</p>
                </div>
            ) : subscriptions.length === 0 ? (
                <div className="psp-placeholder psp-placeholder--card-lg">
                    <div className="psp-auth-card__icon psp-auth-card__icon--spaced">
                        <i className="fas fa-clipboard-list" aria-hidden="true" />
                    </div>
                    <h3 className="psp-placeholder__title psp-placeholder__title--lg">
                        Nenhuma inscrição encontrada
                    </h3>
                    <p className="psp-placeholder__text psp-placeholder__text--lg">
                        Você ainda não se candidatou a nenhuma vaga. Acesse o portal de vagas para encontrar oportunidades e realizar sua inscrição.
                    </p>
                    <button
                        type="button"
                        onClick={() => navigate(base)}
                        className="psp-btn psp-btn--primary psp-btn--inline psp-btn--lg"
                    >
                        Explorar Vagas Disponíveis
                    </button>
                </div>
            ) : (
                <div className="psp-subscription-list">
                    {subscriptions.map((sub) => {
                        const statusBadge = getStatusBadge(sub.status);
                        return (
                            <div key={sub.id} className="psp-subscription-card">
                                <div className="psp-subscription-card__header">
                                    <div>
                                        <span className="psp-subscription-card__number">
                                            Inscrição #{sub.subscription_number}
                                        </span>
                                        <h3 className="psp-subscription-card__title">
                                            {sub.vacancy_title}
                                        </h3>
                                        <span className="psp-subscription-card__process">
                                            Processo: {sub.selection_process_title} {sub.edital_number ? `(Edital ${sub.edital_number})` : ''}
                                        </span>
                                    </div>

                                    <span className={`psp-subscription-card__badge ${statusBadge.modifier}`}>
                                        {statusBadge.text}
                                    </span>
                                </div>

                                <div className="psp-subscription-card__footer">
                                    <span className="psp-subscription-card__date">
                                        <i className="far fa-calendar-alt psp-icon--mr-6" />
                                        Inscrito em {moment(sub.created_at).format('DD/MM/YYYY [às] HH:mm')}
                                    </span>

                                    <button
                                        type="button"
                                        onClick={() => navigate(`${base}/vagas/${sub.vacancy_id}`)}
                                        className="psp-btn psp-btn--outline psp-btn--inline psp-btn--sm"
                                    >
                                        Ver detalhes da vaga
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default Home;
